import cmp from '../../lib/cmp';
import { starsDetailed } from '../../lib/stars';
import { smap } from '../../lib/utils';
import { formatDate } from '../utils/formatDate';
import onResize from '../../lib/dom/on-resize';
import selectByClass, { selectOne } from '../../lib/dom/select-by-class';
import on from '../../lib/dom/on';
import { hasClass, addClass, removeClass } from '../../lib/dom/className';
import elementClosest from '../../lib/dom/element-closest';
import styleFactory from '../../lib/dom/style';
import trackCommentView from '../../lib/track-event/comment-view';
import smEllipsis from '../../components/sm-ellipsis/sm-ellipsis';
import imageStar from '../../images/star';
import Siema from '../../vendor/siema';
import { isRtl } from '../../lib/document-dir-utils';
import './sm-landing-appstore-app-1-comments.less';



const commentView = ($cmp, className = '', ellipsis = true) => ({ title, date, rating, username, comment }, index) => `
  <div class="sm-landing-appstore-app-1-comments__slide${isRtl() ? '-rtl' : ''} ${className}" data-index="${index}">
    <div class="sm-landing-appstore-app-1-comments__item-wr">
      <div class="sm-landing-appstore-app-1-comments__item">
        <div class="sm-landing-appstore-app-1-comments__item-h">
          ${date ? `<div class="sm-landing-appstore-app-1-comments__item-h-second">${formatDate(date)}</div>` : ''}
          <div class="sm-landing-appstore-app-1-comments__item-h-main${isRtl() ? '-rtl' : ''}">${title}</div>
        </div>

        <div class="sm-landing-appstore-app-1-comments__item-data">
          ${rating ? `
            <div class="sm-landing-appstore-app-1-comments__item-data-rating">
              ${smap(starsDetailed(rating), (star, key) => `
                <span class="sm-landing-appstore-app-1-comments__item-data-rating-star${isRtl() ? '-rtl' : ''}">${imageStar({ color: '#fd8407', star, key })}</span>
              `)}
            </div>
          ` : ''}
          ${username ? `<div class="sm-landing-appstore-app-1-comments__item-data-name${isRtl() ? '-rtl' : ''}">${username}</div>` : ''}
        </div>
        ${ellipsis ? $cmp(`sm-landing-appstore-app-1-comments__item-text${isRtl() ? '-rtl' : ''}`, smEllipsis, { prepend: '', text: comment, rows: 3, pre: false, after: `<span class="sm-landing-appstore-app-1-comments__item-text-more${isRtl() ? '-rtl' : ''}">${__('sm@_more')}</span>`, reservedLength: __('sm@_more').length * 3 }) : `<div class="sm-landing-appstore-app-1-comments__item-text">${comment}</div>`}
      </div>
    </div>
  </div>
  `;


const SLIDER_FRAME_CLASS = 'sm-landing-appstore-app-1-comments__slider-container';
const SLIDER_SLIDE_CLASS = 'sm-landing-appstore-app-1-comments__slider-slide';
const POPUP_CLASS = 'sm-landing-appstore-app-1-comments__popup';
const POPUP_HEAD_CLASS = 'sm-landing-appstore-app-1-comments__popup-head';
const POPUP_ACTIVE_CLASS = 'sm-landing-appstore-app-1-comments__popup--active';
const POPUP_SLIDE_CLASS = 'sm-landing-appstore-app-1-comments__popup-slide';



const template = ($cmp, { comments }) => `
  <div class="sm-landing-appstore-app-1-comments">
    <div class="sm-landing-appstore-app-1-comments__in">
      <div class="sm-landing-appstore-app-1-comments__slider">
        <div class="${SLIDER_FRAME_CLASS}">
          ${smap(comments, commentView($cmp, SLIDER_SLIDE_CLASS))}
        </div>
      </div>
    </div>
    ${smap(comments, (comment, index) => `
      <div class="${POPUP_CLASS}">
        <div class="${POPUP_HEAD_CLASS}">
          ${__('sm@_back')}
          <div class="sm-landing-appstore-app-1-comments__popup-head-arrow"></div>
        </div>
        <div class="sm-landing-appstore-app-1-comments__popup-title">${__('sm@_ratings_reviews')}</div>
        ${commentView($cmp, POPUP_SLIDE_CLASS, false)(comment, index)}
      </div>
    `)}
  </div>
  `;


const HTML_POPUP_ACTIVE_CLASS = '-sm-landing-appstore-app-1-comments--popup-active';


export default cmp(null, template, (element) => {
  const htmlElement = document.documentElement;
  const style = styleFactory();
  const frameElement = selectOne(element, SLIDER_FRAME_CLASS);
  const popupElements = selectByClass(element, POPUP_CLASS);
  const popupHeadElements = selectByClass(element, POPUP_HEAD_CLASS);

  const popup = {
    activate () {
      addClass(htmlElement, HTML_POPUP_ACTIVE_CLASS);
    },
    deactivate () {
      removeClass(htmlElement, HTML_POPUP_ACTIVE_CLASS);
    }
  };

  const fullscreenComment = {
    activeIndex: 0,
    activate (index) {
      this.activeIndex = index;
      addClass(popupElements[index], POPUP_ACTIVE_CLASS);
      popup.activate();
      trackCommentView(index, true, false);
    },
    deactivate () {
      const index = this.activeIndex;

      removeClass(popupElements[index], POPUP_ACTIVE_CLASS);
      popup.deactivate();
    }
  };

  const gallery = new Siema(frameElement, {
    onChange (slideIndex) {
      trackCommentView(slideIndex, false, false);
    },
    onClick (ev) { // TODO: show popup
      const slide = elementClosest((element) => hasClass(element, SLIDER_SLIDE_CLASS), ev.target, ev.currentTarget);

      if (!slide) {
        return;
      }

      fullscreenComment.activate(Number(slide.getAttribute('data-index')));
    }
  });

  return [
    style.destroy,
    gallery.destroy,
    onResize(element, (ev, { width }) => {
      style.set(`.${SLIDER_SLIDE_CLASS}{width:${width}px;}`);
      gallery.refresh();
    }, true),
    on(popupHeadElements, 'click', () => {
      fullscreenComment.deactivate();
    })
  ];
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-comments/sm-landing-appstore-app-1-comments.js